import { WizardStep } from "./wizard-step";

/** ###TypeDocName:sd-wizard### */
export class WizardBindings {
  /** Callback invoked when the wizard is judged as being "complete". There are no parameters supplied to this callback.  */
  onFinished = "&?";
}

export interface Wizard {
  stepComplete(nextStep: string): void;
  undoStep(): void;
  registerStep(step: WizardStep): void;
  activeStepName: string;
  finish(): void;
  setWizardBusy(promise: ng.IPromise<any>): void;
}

export class WizardController implements Wizard {
  private stepStack: { stepName: string; state: {} }[] = [];
  private allSteps = new Map<string, WizardStep>();
  private wizardState = {};
  private onFinished: () => void;
  public isWizardBusy: boolean;
  public activeStepName: string;
  // @ngInject
  constructor(private $timeout: ng.ITimeoutService) {}

  public stepComplete(nextStep: string) {
    this.stepStack.push({ stepName: this.activeStepName, state: angular.copy(this.wizardState) });
    this.activeStepName = nextStep;
    this.allSteps.get(nextStep).activateStep(this.wizardState);
  }

  public undoStep(): void {
    let lastEntry = this.stepStack.pop();
    this.activeStepName = lastEntry.stepName;
    this.wizardState = lastEntry.state;
    this.allSteps.get(lastEntry.stepName).activateStep(lastEntry.state);
  }

  public finish(): void {
    this.onFinished();
  }

  public setWizardBusy(promise: ng.IPromise<any>) {
    this.isWizardBusy = true;
    promise.finally(() => (this.isWizardBusy = false));
  }

  public registerStep(step: WizardStep) {
    let isFirstStep = !step.stepName;
    if (isFirstStep) {
      step.stepName = "_sd_internal_first_step";
    }

    if (this.allSteps.has(step.stepName)) {
      throw new Error("Wizard steps must have unique step names!");
    }

    this.allSteps.set(step.stepName, step);

    if (isFirstStep) {
      this.$timeout(() => {
        this.activeStepName = step.stepName;
        step.activateStep(this.wizardState);
      }, 0);
    }
  }
}
export const sdWizard: ng.IComponentOptions = {
  bindings: <any>new WizardBindings(),
  controller: WizardController,
  templateUrl: "../ShellCommon/Controls/wizard/wizard.html",
  transclude: true
};
